var comparisonSwiper;

      function initComparisonSwiper() {
        comparisonSwiper = new Swiper(".fum-comparison-my-swiper", {
          loop: true,
          spaceBetween:0,
          navigation: {
            nextEl: ".fum-swiper-button-next",
            prevEl: ".fum-swiper-button-prev",
          },
        });
      }

      document.addEventListener("DOMContentLoaded", () => {
        initComparisonSwiper();
      });